import { render, staticRenderFns } from "./feed-form.vue?vue&type=template&id=48635e4a&scoped=true&"
import script from "./feed-form.vue?vue&type=script&lang=js&"
export * from "./feed-form.vue?vue&type=script&lang=js&"
import style0 from "./feed-form.vue?vue&type=style&index=0&id=48635e4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48635e4a",
  null
  
)

export default component.exports